<template>
	<modal
		:title="title"
		id="cancel_consent_task"
		cancel-label="Close"
		continue-label="Continue"
		v-on:closed="cancel"
		v-on:confirm="confirmCancel"
		:showModal="showModal"
	>
		<template v-slot:body>
      <span>
          You are about to cancel a consent task for {{ participant }}. Are you sure you want to continue?
      </span>
		</template>
	</modal>
</template>

<script setup>
	import { computed } from 'vue'
	import Modal from '../../Modal.vue'

	const props = defineProps(['consent', 'participant', 'showModal'])
	const emit = defineEmits(['confirm', 'closed'])

	function confirmCancel() {
		emit('confirm')
	}
	function cancel() {
		emit('closed')
	}

	const title = computed(() => {
		return "Cancel Task for "+ props.consent.name
	})
</script>